import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "./Nav";
import { Reveal } from "../components/Reveal";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you submit the Book a Demo form, we collect your name, practice name, email address, phone number and anything you choose to include in the message field. We also hold a record of when the form was submitted.",
  },
  {
    title: "How we use it",
    body: "Your details are used for one purpose only: to respond to your enquiry and arrange a short call about Leadtochair. We do not use your details for marketing lists, newsletters or any other purpose, and we do not contact you beyond what your enquiry requires.",
  },
  {
    title: "Storage and security",
    body: "Submissions are stored securely in our database, with access limited to the people who respond to enquiries. Appropriate technical and organisational measures are in place to protect the information we hold.",
  },
  {
    title: "Sharing",
    body: "We never sell your details and never share them with third parties for their own marketing. Information is only disclosed if required by law.",
  },
  {
    title: "Your rights",
    body: "You can ask to see the information we hold about you, ask us to correct it, or ask us to delete it at any time. To do so, contact us through the demo form or by email and we will action your request promptly.",
  },
  {
    title: "Patient data handled by the service",
    body: "Where Leadtochair is implemented for a practice, any handling of patient-related data is configured together with that practice, with appropriate data-protection requirements in mind and agreed on a case-by-case basis during setup. This page is not legal advice.",
  },
  {
    title: "Contact",
    body: "For any privacy question or request, email ryanaali24@gmail.com or use the contact form on the main page.",
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-paper font-sans text-ink">
      <header className="border-b border-ink/10">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-5">
          <Link to="/" data-testid="privacy-wordmark-link" aria-label="Back to Leadtochair home">
            <Wordmark />
          </Link>
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="flex items-center gap-2 text-sm text-ink/60 transition-colors hover:text-teal"
          >
            <ArrowLeft size={16} />
            Back to site
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-16 md:py-24">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-teal">Leadtochair</p>
          <h1 className="mt-4 font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
            Privacy Policy
          </h1>
          <p className="mt-5 text-sm leading-relaxed text-ink/55">
            Last updated: September 2026. This policy explains what information
            Leadtochair collects through this website and how it is handled.
          </p>
        </Reveal>

        <div className="mt-12 space-y-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={Math.min(i * 60, 240)}>
              <section data-testid={`privacy-section-${i}`}>
                <h2 className="font-display text-xl font-medium text-ink md:text-2xl">{s.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-ink/70 md:text-base">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </main>

      <footer className="border-t border-ink/10 py-8">
        <p className="mx-auto max-w-3xl px-6 text-xs text-ink/45">
          © {new Date().getFullYear()} Leadtochair. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
